module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio70-0e176f6c779d70513aeabd82774f0280.m4a";